/**
 * Created by litao on 2018/10/8.
 */
export default (http) => {
    return {
        /**
         * 查询字典列表
         * @param data
         * @return {*}
         */
        queryDeposList(data) {
            return http.json({
                url: '/deposit/loge/query',
                data
            })
        },

        goBackPrice(data) {
            return http.json({
                url: '/deposit/loge/goBackPrice',
                data
            })
        },

    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/deposit.js